<script >
import { ref, defineAsyncComponent, onBeforeMount } from 'vue-demi';
const SparkChart = defineAsyncComponent(() => import('@futuweb/quote-charts/lib/SparkChart'));
import '@futuweb/quote-charts/lib/SparkChart/style/index.css';
import { getSchemeLink, PROTOCOL_TYPE } from '../common/scheme';
import useCustomRank from './useCustomRank';
import useMarketRank from './useMarketRank';
import useChartData from './useChartData';
const __sfc_main = {};
__sfc_main.props = {
  market_id: [Number, String],
  sort_id: Number,
  language: Number,
  upDownColor: Number,
  title: String,
  subTitle: String,
  topImg: String,
  count: Number,
  customStocklist: Array,
  schemeType: String,
  rankType: String,
  schemeProtocol: {
    type: String,
    default: PROTOCOL_TYPE.MOOMOO
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const DEFAULT_IMG =
  // eslint-disable-next-line max-len
  'https://static.futunn.com/upload/01fego/wecom-temp-a4a5d8dc67ffbdb20d121301fcdc00ab-a5f06cc9f247bd53342ca7899d7edad9.png?_=1680160592562';
  const {
    usePageType,
    useCommonApi,
    useBehaviour
  } = require('@fegobull/webapi').use;
  const {
    isPC
  } = usePageType();
  const props = __props;
  const request = useCommonApi('quote-rank');
  /* 自定义排行 */
  const {
    isCustomRank,
    getCustomRank
  } = useCustomRank(props, request);

  /* 市场排行 */
  const {
    getMarketRank
  } = useMarketRank(props, request);

  /* 图表数据 */
  const stockList = ref([]);
  const {
    initChartData,
    chartDatas
  } = useChartData(stockList, request);
  onBeforeMount(async () => {
    stockList.value = isCustomRank.value ? await getCustomRank() : await getMarketRank();
    initChartData();
  });
  const {
    runBehaviour
  } = useBehaviour();
  /* 点击跳转 */
  const goScheme = ($event, stock) => {
    if (props.schemeType) {
      const link = getSchemeLink(props.schemeType, stock, props.schemeProtocol || PROTOCOL_TYPE.MOOMOO);
      link && runBehaviour(null, {
        type: props.schemeProtocol === PROTOCOL_TYPE.NN ? 'jump' : 'jumpMM',
        value: link
      }, $event);
    }
  };
  return {
    DEFAULT_IMG,
    isPC,
    stockList,
    chartDatas,
    goScheme
  };
};
__sfc_main.components = Object.assign({
  SparkChart
}, __sfc_main.components);
export default __sfc_main;
</script>
<template>
    <div
        :class="[
            'quote-rank',
            {
                pc: isPC
            }
        ]"
    >
        <div class="topbar">
            <img class="banner" :src="topImg || DEFAULT_IMG" alt="" />
            <p class="title" v-html="title"></p>
            <p class="sub-title" v-html="subTitle"></p>
        </div>
        <div class="stocks">
            <div class="stock-item" v-for="(stock, index) in stockList" :key="index" @click="goScheme($event, stock)">
                <div :class="['rank', { after: index > 2 }]">{{ index + 1 }}</div>
                <div class="left">
                    <div class="short-name">{{ stock.shortName }}</div>
                    <div class="name">{{ stock.name }}</div>
                </div>
                <div class="right">
                    <SparkChart
                        v-if="chartDatas && chartDatas[stock.stockId]"
                        class="chart"
                        :dataSource="chartDatas && chartDatas[stock.stockId]"
                        :upDownColor="upDownColor"
                        :marketId="market_id"
                    />
                    <span :class="[`ratio color-${upDownColor || 0}`, { down: stock.priceChange < 0 }]">
                        {{ stock.ratioPriceChange }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
@import './index.less';
</style>
